<template>
    <div class="
       events container container--grid mt-24 -mb-24
        sm:mt-24 sm:-mb-5
        md:mt-28 md:mb-0
        xxl:mb-48 xxl:mt-56
    ">
        <div class="
            col-span-4 mb-14
            sm:col-span-10 sm:col-start-2 sm:grid sm:grid-cols-10
            md:col-span-3 md:col-start-2 md:block md:mb-0
        ">
            <h2 class="
                font-Midight24 text-center text-30 mb-16 
                sm:col-span-6 sm:text-left sm:pr-20
                md:hidden
            ">Find more reasons to visit or stay.</h2>
            <div class="sm:col-span-4">
                <Datepicker 
                    v-model="today" 
                    inline 
                    autoApply 
                    :markers="markers"
                    :enableTimePicker="false"
                    :monthChangeOnScroll="false"
                    @update:modelValue="handleDate" 
                >
                    <template #arrow-left>
                        <svg width="26.109" height="26.764" viewBox="0 0 26.109 26.764">
                            <g transform="translate(26.109 26.057) rotate(180)">
                                <path d="M-10068.383-12686.406h24.7" transform="translate(10068.383 12699.082)" fill="none" stroke="#000" stroke-width="2"/>
                                <path d="M-10015.158-12732.078l12.676,12.676-12.676,12.674" transform="translate(10027.178 12732.078)" fill="none" stroke="#000" stroke-width="2"/>
                            </g>
                        </svg>
                    </template>
                    <template #arrow-right>
                        <svg width="26.109" height="26.764" viewBox="0 0 26.109 26.764">
                            <g transform="translate(0 0.707)">
                                <path d="M-10068.383-12686.406h24.7" transform="translate(10068.383 12699.082)" fill="none" stroke="#000" stroke-width="2"/>
                                <path d="M-10015.158-12732.078l12.676,12.676-12.676,12.674" transform="translate(10027.178 12732.078)" fill="none" stroke="#000" stroke-width="2"/>
                            </g>
                        </svg>
                    </template>
                </Datepicker>
            </div>
        </div>
        <div class="
            flex flex-col justify-between col-span-4
            sm:col-span-10 sm:col-start-2
            md:col-span-6 md:col-start-6
        ">
            <h2 class="
                font-Midight24 text-20 mb-14 hidden
                md:block md:text-30 md:w-3/4 md:mb-8
                xxl:text-left xxl:w-1/2 xxl:mb-20 xxl:text-50
            ">Find more reasons to visit or stay.</h2>
            <div>
                <div class="hidden flex-wrap sm:flex sm:mb-4 xxl:mb-14">
                    <p class="w-full sm:text-13 sm:mb-4 xxl:mb-8 xxl:text-20">Location</p>
                    <div 
                        class="
                            cursor-pointer underline decoration-1 underline-offset-2 text-24 mb-6 mr-6 hover:text-black
                            sm:text-20 sm:mb-4
                            md:text-20
                            xxl:mr-14 xxl:text-30
                        "
                        :class="{'text-black' : curLocation === 'all', 'text-blue' : curLocation !== 'all'}"
                        @click="curLocation = 'all', current = 1"
                    >
                        All
                    </div>
                    <div 
                        class="
                            cursor-pointer underline decoration-1 underline-offset-2 text-24 mb-6 mr-6 hover:text-black
                            sm:text-20 sm:mb-4
                            md:text-20
                            xxl:mr-14 xxl:text-30
                        "
                        :class="{'text-black' : location.slug === curLocation, 'text-blue' : location.slug !== curLocation}"
                        v-for="location in locations" 
                        :key="location.slug" 
                        @click="curLocation = location.slug, current = 1"
                    >
                        {{ location.name }}
                    </div>
                </div>
                <div class="
                    flex flex-wrap border-cream border-t border-b pt-7 pb-1
                    sm:border-none sm:pt-0 sm:pb-0
                ">
                    <p class="hidden w-full sm:block sm:text-13 sm:mb-4 xxl:mb-8 xxl:text-20">Type</p>
                    <div 
                        class="
                            label label--blue cursor-pointer text-15 text-center leading-none uppercase  mb-6 mr-6 border border-blue
                            sm:mr-1
                            md:mr-3.5
                            xxl:mb-8 xxl:mr-2
                            hover:opacity-100
                        "
                        :class="{'opacity-100' : curType === 'all', 'opacity-25' : curType !== 'all'}"
                        @click="curType = 'all', current = 1"
                    >
                        All
                    </div>
                    <div
                        class="
                            cursor-pointer label uppercase  mb-6 mr-6
                            sm:mr-1
                            md:mr-3.5
                            xxl:mb-8 xxl:mr-2
                            hover:opacity-100
                        " 
                        :class="{
                            'label--yellow' : type.slug === 'dojo',
                            'label--blue' : type.slug !== 'dojo',
                            'opacity-100' : type.slug === curType && type.slug === 'all',
                            'opacity-25' : type.slug !== curType && curType !== 'all',
                        }"
                        v-for="type in types" 
                        :key="type.slug"
                        @click="curType = type.slug, current = 1"
                    >
                        {{ type.name }}
                    </div>
                </div>
            </div>
        </div>
        <eventsPosts :posts="printedPosts" :today="today"></eventsPosts>
        
        <span v-show="postsList.length > curLastIndex"
              @click="loadMore"
              class="mt-10 col-span-4 mx-auto cursor-pointer link | sm:col-span-12 sm:mt-12 | md:mt-20 | lg:mt-24"
        >
            load more
        </span>
    </div> 
</template>

<script>
import moment from 'moment';

import eventsPosts from './partials/events-posts.vue';

const INPUT_DATE_FORMAT = 'DD-MM-YYYY';

export default {
    data() {
        return {
            isLoading: true,
            search: '',
            isActiveEventsArchive: true,
            perPage: parseInt(this.postsPerPage),
            lastItem: parseInt(this.postsPerPage),
            posts: this.json,
            step: parseInt(this.loadStep),
            dateRange: [],
            today: new Date(),
            markers: [],
            curType: 'all',
            curLocation: 'all',
            curLastIndex: this.perPage,
            current: 1
        }
    },

    props: {
        json: [Object, Array],
        postsPerPage: [Number, String],
        loadStep: [Number, String],
        // filterPlaceholder: String,
        types: [Object, Array],
        locations: [Object, Array]
    },
    watch: {
        today(newToDay, oldToDay) {
        //   console.log(newToDay);
          sessionStorage.setItem('event-today', newToDay);
        }, 
        curType(newCurType, oldCurType) {
            // console.log(newCurType);
            sessionStorage.setItem('event-type', newCurType);
        },
        curLocation(newCurLocation, oldCurType) {
            // console.log(newCurLocation);
            sessionStorage.setItem('event-location', newCurLocation);
        },
    },
    created() {
        this.markersDate();

        // const today = new Date();
        // this.today = today.setHours(0,0,0,0);

        // console.log(today);
    },
    mounted() {
        this.loadFilters();
    },
    computed: {
        postsList() {
            let posts = this.posts;
            this.curLastIndex = this.perPage;

            // Hide passed by events
            posts = posts.filter(post => {
                // check event type
                if (post.type === 'recurring') {
                    let momentStartDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT),
                        momentEndDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT).add(post.reccuring_data.duration, 'M');

                    // Add Date intervals
                    let loopedTime = momentStartDate.clone();
                    post.interval_dates = [momentStartDate.format()];

                    switch (post.reccuring_data.repeat_every) {
                        case 'per_week':
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        case '2_weeks':
                            while (loopedTime.add(2, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        case '3_weeks':
                            while (loopedTime.add(3, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        default:
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                    }

                    // Add Custom dates
                    const customDates = post.reccuring_data.custom_dates;
                    if (customDates) {
                        for (const customDate of customDates) {
                            post.interval_dates.push(moment(customDate.custom_date,INPUT_DATE_FORMAT).format());
                        }
                    }

                    // Set Nearest past and current dates
          
                    post.interval_dates = post.interval_dates.map((x) => {
                        return moment(x);
                    }).sort((x, y) => {
                        return x.diff(y)
                    });
        
                    let nearestStart = post.interval_dates.find((x) => {
                        return x.isSameOrAfter();
                    });

                    let nearestPastStart = post.interval_dates.reverse().find((x) => {
                        return x.isBefore();
                    });
      
                    // Set event as future/past
                    if (this.isActiveEventsArchive) {
                        post.start_date = nearestStart;
                        return post.interval_dates.some(date => moment(date).isAfter(this.today))
                    } else {
                        post.start_date = nearestPastStart;
                        return post.interval_dates.some(date => moment(date).isSameOrBefore(this.today))
                    }

                } else {
                    
                    const today = moment(this.today,INPUT_DATE_FORMAT).format('YYYY-MM-DD');
                    
                    post.interval_dates = [];

                    if(post.normal_dates && post.normal_dates.dates){
                        post.interval_dates = post.normal_dates.dates.map((x) => {
                            return moment(x.date,INPUT_DATE_FORMAT);
                        }).sort((x, y) => {
                            return x.diff(y)
                        });
                    }
                    
                    let nearestStart = post.interval_dates.find((x) => {
                        return x.isSameOrAfter();
                    });

                    let nearestPastStart = post.interval_dates.reverse().find((x) => {
                        return x.isBefore();
                    });
                    
                    if (this.isActiveEventsArchive) {
                        post.start_date = nearestStart;
                        return post.interval_dates.some(date => moment(date).isAfter(this.today))
                    } else {
                        post.start_date = nearestPastStart;
                        return post.interval_dates.some(date => moment(date).isSameOrBefore(this.today))
                    }
                }

            })

            // Sort Upcoming events by closest date
            posts = posts.sort((firstEvent, secondEvent) => {
                let dateFirst = false;
                let dateSecond = false;

                // console.log(firstEvent, secondEvent);
                
                // Duration
                let today = moment(this.today,INPUT_DATE_FORMAT).format('YYYY-MM-DD');

                let datesFirst = firstEvent.interval_dates.filter(item => {
                    if ( moment(item).isSameOrAfter(today) ) {
                        return item;
                    }
                }).sort((x, y) => {
                    return x.diff(y)
                });

                dateFirst = datesFirst[0];
                
                let datesSecond = secondEvent.interval_dates.filter(item => {
                    if ( moment(item).isSameOrAfter(today) ) {
                        return item;
                    }
                }).sort((x, y) => {
                    return x.diff(y)
                });

                dateSecond = datesSecond[0];
                
          
                // var distancea = Math.abs(moment(this.today).format('YYYY-MM-DD') - moment(dateFirst).format('YYYY-MM-DD'));
                // var distanceb = Math.abs(moment(this.today).format('YYYY-MM-DD') - moment(dateSecond).format('YYYY-MM-DD'));

                // console.log(dateFirst, dateSecond);
            //     console.log(dateSecond);.sort((x, y) => {
            //     return x.diff(y)
            // });
                return dateFirst.diff(dateSecond);
                // return distancea - distanceb;
            });

            // Filter types
            posts = posts.filter(post => {
                if (this.curType !== 'all') {
                    if ( post.types ) {
                        return post.types.some(type => type.slug === this.curType)
                    }
                } else {
                    return post;
                }
            });

            // Filter Locations
            posts = posts.filter(post => {
                if (this.curLocation !== 'all') {
                    if ( post.locations ) {
                        return post.locations.some(location => location.slug === this.curLocation)
                    }
                } else {
                    return post;
                }
            });

            // Return posts with all filters and sorted
            return posts;
        },

        printedPosts() {
            return this.postsList.slice(0, this.curLastIndex);
        },
    },

    methods: {
        loadFilters() {
            if ( window.location.hash === '#return' ) {
                this.today = sessionStorage.getItem('event-today') ?? new Date();
                this.curType = sessionStorage.getItem('event-type') ?? 'all';
                this.curLocation = sessionStorage.getItem('event-location') ?? 'all';
                history.pushState("", document.title, window.location.pathname + window.location.search);
                
                window.setTimeout(() => {
                    window.scrollTo({top: document.querySelector('.events').getBoundingClientRect().top, behavior: "smooth"});
                }, 1000);
            }
            else if ( window.location.hash === '#dojo' ) {
                this.curType = 'dojo';
            }
        },
        handleDate() {
            this.current = 1;
        },
        loadMore(){
          this.curLastIndex += this.step;
        },
        markersDate() {
            let markers = [];
            this.posts.filter(post => {
                // check event type
                if (post.type === 'recurring') {
                    // Recurring date
                    markers.push({date: moment(post.reccuring_data.date,INPUT_DATE_FORMAT).format()});
                    
                    // Custom dates
                    if( post.reccuring_data.custom_dates ) {
                        post.reccuring_data.custom_dates.map((item, index) => {
                            markers.push({date: moment(item.custom_date,INPUT_DATE_FORMAT).format() });
                        });
                    }

                    // Duration
                    let momentStartDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT),
                        momentEndDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT).add(post.reccuring_data.duration, 'M');

                    // Add Date intervals
                    let loopedTime = momentStartDate.clone();
                        post.interval_dates = [momentStartDate.format()];

                    switch (post.reccuring_data.repeat_every) {
                        case 'per_week':
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                markers.push({date: loopedTime.clone().format()});
                            }
                            break;
                        case '2_weeks':
                            while (loopedTime.add(2, 'w').isSameOrBefore(momentEndDate)) {
                                markers.push({date: loopedTime.clone().format()});
                            }
                            break;
                        case '3_weeks':
                            while (loopedTime.add(3, 'w').isSameOrBefore(momentEndDate)) {
                                markers.push({date: loopedTime.clone().format()});
                            }
                            break;
                        default:
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                markers.push({date: loopedTime.clone().format()});
                            }
                            break;
                    }

                } else {
                    // Date
                    if(post.normal_dates && post.normal_dates.dates){
                        post.normal_dates.dates.forEach(item =>{
                            markers.push({date: moment(item.date,INPUT_DATE_FORMAT).format()});
                        })
                    }
                }
            });

            // markers.filter(item => {
            //     if ( moment(item.date).isSameOrAfter(this.today) ) {
            //         return item;
            //     }
            // });

            this.markers = markers;

        },
    },
    components: {
        eventsPosts
    },
}
</script>

<style lang="scss">
</style>